import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/index';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  .render(
      <App />
  );
